import React, { useEffect, useState } from "react";
import { Box, Flex, Heading, VStack, Button, Text } from "@chakra-ui/react";
import axios from "axios";
import BoardsButtons from "./BoardsButtons";
import BoardQualificationBadge from "./BoardQualificationBadge";
import { useNavigate } from "react-router-dom";
import { BASE_API_URL } from "./config";
import { ONBOARDING_VERSION } from "./onboardingVersion";



const Onboarding = () => {
  const [boards, setBoards] = useState([]);
  const [qualifications, setQualifications] = useState([]);
  const [selectedBoard, setSelectedBoard] = useState(null);
  const [selectedQualification, setSelectedQualification] = useState(null);
  const [step, setStep] = useState(1);
  const navigate = useNavigate();
 


  useEffect(() => {
    axios.get(`${BASE_API_URL}/api/v1/exam-boards/`).then(r => setBoards(r.data));
  }, []);

  const handleSelectBoard = (label) => {
    const b = boards.find(x => (x.name || x.code) === label || x.code === label);
    if (!b) return;
    setSelectedBoard(b);
    axios.get(`${BASE_API_URL}/api/v1/exam-qualifications/by-exam-board-guid/${b.guid}`).then(r => {
      setQualifications(r.data);
      setStep(2);
    });
  };

  const handleSelectQualification = (label) => {
    const q = qualifications.find(x => (x.name || x.code) === label || x.code === label);
    if (!q) return;
    setSelectedQualification(q);
    setStep(3);
  };

  const handleContinue = () => {
    if (!selectedBoard || !selectedQualification) return;
  
    localStorage.setItem("selectedBoardGuid", selectedBoard.guid);
    localStorage.setItem("selectedQualificationGuid", selectedQualification.guid);
  
    localStorage.setItem("hasCompletedOnboarding", "true"); // legacy key (kept for compatibility)
    localStorage.setItem("hasCompletedOnboardingVersion", ONBOARDING_VERSION);
  
    const defaultHomeUrl =
      `/subjects?boardGuid=${selectedBoard.guid}` +
      `&boardName=${encodeURIComponent(selectedBoard.name || selectedBoard.code)}` +
      `&qualificationGuid=${selectedQualification.guid}` +
      `&qualificationCode=${encodeURIComponent(selectedQualification.code || selectedQualification.name)}`;
  
    localStorage.setItem("defaultHomeUrl", defaultHomeUrl);
  
    navigate(defaultHomeUrl);
  };
  
  const boardLabels = boards.map(b => b.code || b.name);
  const qualificationLabels = qualifications.map(q => q.code || q.name);
  const titleStyle = { color: "#000", textAlign: "center", fontSize: "48px", fontWeight: "600", lineHeight: "normal" };

  return (
    <Flex minH="100vh" align="center" justify="center" bg="#F9F9F9" px={{ base: 6, md: 0 }}>
      <VStack spacing="28px">
        {step === 1 && (
          <> 
            <Heading sx={titleStyle}>Which Board Exam You Want to Prepare For ?</Heading>
            <BoardsButtons items={boardLabels} onSelect={handleSelectBoard} />
          </>
        )}
        {step === 2 && (
          <>
            <Heading sx={titleStyle}>{`Which ${selectedBoard?.name || selectedBoard?.code} Qualification You Want to Prepare For ?`}</Heading>
            <BoardsButtons items={qualificationLabels} onSelect={handleSelectQualification} />
          </>
        )}
        {step === 3 && (
          <>
            <VStack spacing="18px">
              <Heading sx={titleStyle}>Get Ready To Solve & Improve Your Exam Performance for</Heading>
              <BoardQualificationBadge
                board={selectedBoard?.name || selectedBoard?.code}
                qualification={selectedQualification?.code || selectedQualification?.name}
              />
            </VStack>
            <Button
              mt="16px"
              px="24px"
              py="12px"
              borderRadius="14px"
              bg="rgba(75, 255, 92, 0.80)"
              color="#08250B"
              fontSize="16px"
              fontWeight="500"
              onClick={handleContinue}
            >
              Continue
            </Button>
            <Text fontSize="12px" color="#8A8A8A">Cambridge refers to CIE</Text>
          </>
        )}
      </VStack>
    </Flex>
  );
};

export default Onboarding;

